module.exports = __webpack_public_path__ + "img/telegram_ti.52259ec1.png";